import { getCurrentBalance } from "../../js/api/balance.js";
import { getUsers, blockusers } from "../../js/api/users.js";

let Users = {

  render: async () => {

    let users = await getUsers();
    let myUser = users.data.user;
    let childrenUsers = users.data.children_users;
    let usersView = ``;
    let myUserView = ``;
    let eur = 0;
    let usd = 0;
    let lek = 0;
    if (myUser.total_coins.includes('|')) {
      const allCurrencies = myUser.total_coins.split('|');


      allCurrencies.forEach(currency => {
        const id = currency.split(';')[0].split('.')[0];
        const value = currency.split(';')[1];
        if (id == 1) eur += parseFloat(value);
        if (id == 2) lek += parseFloat(value);
        if (id == 3) usd += parseFloat(value);
      });
    }
    else {
      if (myUser.currency_id) {
        if (myUser.currency_id == 1) eur += parseFloat(myUser.total_coins);
        if (myUser.currency_id == 2) lek += parseFloat(myUser.total_coins);
        if (myUser.currency_id == 3) usd += parseFloat(myUser.total_coins);
      } else {
        const value = myUser.total_coins.split(';')[1];

        const id = myUser.total_coins.split(';')[0].split('.')[0];

        if (id == 1) eur += parseFloat(value);
        if (id == 2) lek += parseFloat(value);
        if (id == 3) usd += parseFloat(value);
      }

    }
    myUserView = myUserView + `<div class="myBalanceTableRow">
                    <span>${myUser.name}</span>
                    <span>${parseFloat(eur).toFixed(2)}</span>
                    <span>${parseFloat(lek).toFixed(2)}</span>
                    <span>${parseFloat(usd).toFixed(2)}</span>
               </div>`;


    const uniqueChildrenUsers = [
      ...new Set(childrenUsers.map((item) => item.username)),
    ].sort();

    uniqueChildrenUsers.forEach((childrenUser) => {
      const users = childrenUsers.filter(a => a.username == childrenUser);
      console.log(users);
      usersView = usersView + `<div  class="myBalanceTableRow2 ${users[0].state == 1 ? 'notBlocked' : 'blocked' } ${users[0].state == 1 ? 'visible' : ''}"><a href="#/userprofile/${users[0].id}">`;


      usersView = usersView + `              <span>${childrenUser}</span>
                  <span>${parseFloat(users.filter(a => a.currency == "EURO")[0] ? users.filter(a => a.currency == "EURO")[0].total_coins : 0).toFixed(2)}</span>
                  <span>${parseFloat(users.filter(a => a.currency == "LEK")[0] ? users.filter(a => a.currency == "LEK")[0].total_coins : 0).toFixed(2)}</span>
                  <span>${parseFloat(users.filter(a => a.currency == "USD")[0] ? users.filter(a => a.currency == "USD")[0].total_coins : 0).toFixed(2)}</span>
                  `;

      usersView = usersView + `         </a>
      ${users[0].state == "1" ? `<span><a class="generalButton-small blockUser" data-child-id="${users[0].id}" data-state="3" id="returnCanceledBtn">Blloko</a></span>` : `<span><a class="generalButtonGreen-small blockUser"  data-child-id="${users[0].id}"  data-state="1" id="returnCanceledBtn">Ç'blloko</a></span>`}</div>`;

    });

    let view =  /*html*/`
            <div class="usersHeader m-t-6">
                 <a class="backBtn">
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
                 </a>
                 <span>Users</span>
           </div>
           <div class="tableLabel m-t-50">
               <span>Balanca ime</span>
            </div>
           <div class="userContent">
               <div class="myBalanceTable">
                   <div class="myBalanceTableHeader">
                       <span></span>
                       <span>EURO</span>
                       <span>LEK</span>
                       <span>USD</span>
                    </div>
                   ${myUserView}
               </div>
           </div>
           <div class="filterWrapperMain">
              <a class="filterBtnMain notBlockedPlayer active">Aktiv</a>
              <a class="filterBtnMain blockedPlayer">Te bllokuar</a>
            </div>
           <div class="tableLabel">
               <span>Balanca e secilit perdorues <a class="generalButton-sm blockUser" id="returnCanceledBtn"  data-child-id="0">Blloko të gjithë</a></span>
               
               
            </div>
            <div class="usersContent">
               <div class="myBalanceTable">
                    <div class="searchUserwrapper aktiveSearch active">
                      <span>Search:</span>
                      <input class="searchUser " type="text" />
                    </div>
                    <div class="searchUserwrapper blockedSearch">
                      <span>Search:</span>
                      <input class="searchUser" type="text" />
                    </div>
                   <div class="myBalanceTableHeader2">
                       <span></span>
                       <span>EURO</span>
                       <span>LEK</span>
                       <span>USD</span>
                       <span>Blloko</span>
                    </div>
                    
                    ${usersView}
               </div>
           </div>
       `
    return view
  }
  , after_render: async () => {


    $('body').on('keyup', '.aktiveSearch input', function(e){
      console.log($(e.currentTarget).val().toLowerCase(), 'asdasdasd');
        $(e.currentTarget).parent().parent().addClass('searchPerformed');
        $(e.currentTarget).parent().parent().children('.notBlocked').each(function(i, item){
            if( $(item).children('a').children('span:first').text().toLowerCase().includes($(e.currentTarget).val().toLowerCase())){
              $(item).addClass('searchFound');
            }else {
              $(item).removeClass('searchFound');
            }
        });
    });

    $('body').on('keyup', '.blockedSearch input', function(e){
      console.log($(e.currentTarget).val().toLowerCase());
      $(e.currentTarget).parent().parent().addClass('searchPerformed');
      $(e.currentTarget).parent().parent().children('.blocked ').each(function(i, item){
          if( $(item).children('a').children('span:first').text().toLowerCase().includes($(e.currentTarget).val().toLowerCase())){
            $(item).addClass('searchFound');
          }else {
            $(item).removeClass('searchFound');
          }
      });
  });


    $('body').on('click', '.filterBtnMain', function(e){
      $(e.currentTarget).parent().children('a').removeClass('active');
      $(e.currentTarget).addClass('active');

      $('.aktiveSearch input').val('');
      $('.myBalanceTable').removeClass('searchPerformed');
      $('.myBalanceTableRow2').removeClass('searchFound');

      if( $(e.currentTarget).hasClass('notBlockedPlayer') ){
        $('body .searchUser').val('');
        $('body .searchUserwrapper.aktiveSearch ').addClass('active');
        $('body .searchUserwrapper.blockedSearch').removeClass('active');

        $('body .myBalanceTableRow2').each(function(i, item){
          if( $(item).hasClass('notBlocked') ){
            $(item).addClass('visible');
          }else {
            $(item).removeClass('visible');
          }
        });
      }
      if( $(e.currentTarget).hasClass('blockedPlayer') ){
        $('body .searchUser').val('');
        $('body .searchUserwrapper.blockedSearch ').addClass('active');
        $('body .searchUserwrapper.aktiveSearch').removeClass('active');

        $('body .myBalanceTableRow2').each(function(i, item){
          if( $(item).hasClass('blocked') ){
            $(item).addClass('visible');
          }else {
            $(item).removeClass('visible');
          }
        });
      }
    });
    var currentBalanceResult = await getCurrentBalance();
    var coins = [];
    var allText = '';

    var allCoins = currentBalanceResult.total_coins.split('|');

    if (currentBalanceResult.total_coins.includes('|')) {
      var allCoins = currentBalanceResult.total_coins.split('|');

      for (let index = 0; index < allCoins.length; index++) {
        const coin = allCoins[index];
        const currency = coin.split(';')[0].split('.')[1];
        coins.push({
          currency,
          id: coin.split(';')[0].split('.')[0]
        });

        const value = coin.split(';')[1];
        allText += `<b>${currency} ${parseFloat(value).toFixed(2)}  </b>`;
      }
    } else {
      if (currentBalanceResult.currency) {
        coins.push({
          currency: currentBalanceResult.currency,
          id: currentBalanceResult.currency_id,
        });
        allText += `<b>${currentBalanceResult.currency} ${parseFloat(currentBalanceResult.total_coins).toFixed(2)} </b>`;
      } else {
        const currency = currentBalanceResult.total_coins.split(';')[0].split('.')[1];
        coins.push({
          currency,
          id: currentBalanceResult.total_coins.split(';')[0].split('.')[0]
        });

        const value = currentBalanceResult.total_coins.split(';')[1];
        allText += `<b>${currency} ${parseFloat(value).toFixed(2)}  </b>`;
      }
    }

    $('.currentBalanceNew').html(allText);

    localStorage.setItem('coins', JSON.stringify(coins));


    $('body').on('click', '.blockUser', async function (e) {
      e.preventDefault()
      e.stopPropagation();
      e.stopImmediatePropagation();
      let childId = $(e.currentTarget).attr('data-child-id');
      let state = $(e.currentTarget).attr('data-state');
      console.log(childId);
      var r = confirm("Jeni te sigurt?");
      if (r == true) {
        const res = await blockusers(childId, state);
        location.reload();

      }
    });
  }

}

export default Users;